<template>
  <div class="">
    <div class="body-container">
      <ul class='circle-container'>
        <li>
          <a :href="links.lessonLearnedLibrary" target="_blank">
            <img src='assets/Menu/Lessons Learned-01.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.projectInduction" target="_blank">
            <img src='assets/Menu/Project Induction.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.projectDocuments" target="_blank">
            <img src='assets/Menu/Project Documents.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.contactList" target="_blank">
            <img src='assets/Menu/Contact List.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.actionsList" target="_blank">
            <img src='assets/Menu/Actions List-01.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.designPortal" target="_blank">
            <img src='assets/Menu/Design Portal-01.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.projectManagementPlan" target="_blank">
            <img src='assets/Menu/Project Mgt Plan.svg' alt="..." />
          </a>
        </li>
        <li>
          <a :href="links.fileTransfer" target="_blank">
            <img src='assets/Menu/File Transfer.svg' alt="..." />

          </a>
        </li>
        <li>
          <img class="middle-circle" src='assets/Menu/Central Hub-01.svg' alt="..." />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircularContainer',
  data() {
    return {
      links: {
        communityPortal: "http://under-construction.geodemosolutions.com/",
        fileTransfer: "https://arcadiso365.sharepoint.com/sites/AUS-PS10/CPRP/Transfer/Forms/AllItems.aspx",
        projectInduction: "https://arcadiso365.sharepoint.com/sites/AUS-PS10/CPRP/Project%20Induction/Forms/AllItems.aspx",
        projectDocuments: "http://under-construction.geodemosolutions.com/",
        // peopleDetails: "http://under-construction.geodemosolutions.com/",
        contactList: "https://arcadiso365.sharepoint.com/sites/AUS-PS10/CPRP/Lists/Contact%20List/AllItems.aspx",
        actionsList: "https://arcadiso365.sharepoint.com/sites/AUS-PS10/CPRP/Lists/Action%20List/AllItems.aspx",
        // designPortal: "https://transport-central-3d-commenting.geodemosolutions.com/",
        designPortal: "https://arcadis.maps.arcgis.com/apps/MapSeries/index.html?appid=612d2ff8cdfb4307b3fdfadfeb293fee",
        // stakeholderPortal: "http://under-construction.geodemosolutions.com/",
        projectManagementPlan: "http://under-construction.geodemosolutions.com/",
        lessonLearnedLibrary: "http://under-construction.geodemosolutions.com/",
        tfnswProjectPage: "https://www.transport.nsw.gov.au/projects",
        inEightWebsite: "https://ineight.com/solutions/collaborative-document-management/"
      },
    }
  },
}
</script>

<style>
</style>
